import { ApiManager } from '../../core/api-manager';
import { DataManager } from '../../core/data-manager';
import { settings } from '../../config/settings';
import { LanguageProvider } from '../../core/language-provider';
import { toast } from 'react-toastify';



export async function preUpdate(entity, data, id) {

    var d = { ...data }

    if (entity === 'sample') {
        d.sample1 = 'test'
    }
    if (entity === "job_request") {
        console.log(data)
        if (data.source && data.source === "10_AGENCY") {
            if (data.idAgency === null) {
                toast.error("Selezionare un'agenzia per continuare.", { theme: 'colored' })
                return {
                    success: 0,
                    data: d,
                    message: 'Il campo Agenzia deve essere compilato'
                }
            }
        }
    }

    return {
        success: 1,
        data: d,
        message: ''
    }
}